import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalDelete, Table } from '..';
import { VEHICLE_TYPES_HEADERS } from '../../constants/table-headers';
import useDeleteVehicleType from '../../hooks/vehicleType/useDeleteVehicleType';
import UseGetVehicleType from '../../hooks/vehicleType/useGetVehicleType';
import useGetVehicleTypes from '../../hooks/vehicleType/useGetVehicleTypes';
import history from '../../services/history';
import { ApplicationState } from '../../store';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import './styles.scss';
import BoxWrapper from '../atoms/boxWrapper';
import { Grid, Paper } from '@material-ui/core';
import InputBase from '@mui/material/InputBase';
import commons from '../../assets/styles/commons';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as SearchIcon } from '../../assets/icons/icon-search.svg';

const TableVehicleTypes: React.FC = () => {
  const { vehicleTypes } = useSelector(
    (state: ApplicationState) => state.tables,
  );

  const { execute, loading } = useGetVehicleTypes();
  const { execute: executeDelete, loading: loadingDelete } =
    useDeleteVehicleType();
  const { execute: getVehicleType, loading: loadingGetVehicleType } =
    UseGetVehicleType();
  const [flag, setFlag] = useState<boolean>(false);
  const [id, setId] = useState<string>('');
  const [currentPage, setCurrentPage] = useState(1);
  const [vehicleTypeName, setVehicleTypeName] = useState('');
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [itemsPerPage] = useState<number>(10);

  const handleFilters = async () => {
    await execute(currentPage, vehicleTypeName);
  };

  const handleDelete = async () => {
    await Promise.all([
      executeDelete(id),
      execute(currentPage, vehicleTypeName),
    ]);
    setFlag(false);
  };

  useEffect(() => {
    const loadVehicleTypes = async () => {
      await execute(currentPage);
    };

    loadVehicleTypes();
    setTotalRecords(vehicleTypes.rows.length);
    //eslint-disable-next-line
  }, [currentPage]);

  const handleEditVehicleType = async (id: string) => {
    await getVehicleType(id);
    history.push(`/home/vehicle-types/edit`);
  };

  if (loading || loadingDelete || loadingGetVehicleType) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <ModalDelete
        onHide={() => setFlag(false)}
        onConfirmClick={handleDelete}
        show={flag}
        message="Deseja excluir o tipo de veículo?"
      />

      <Grid item style={{ flex: 1 }}>
        <Paper
          component="form"
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            border: '1px solid #FF7206',
            backgroundColor: '#F7F9FC',
          }}
        >
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              fontFamily: commons.fontFamily,
            }}
            placeholder="Buscar tipo de veículo"
            value={vehicleTypeName}
            onChange={event => setVehicleTypeName(event.target.value)}
            inputProps={{ maxLength: 30 }}
          />
          <IconButton
            type="button"
            className="search-button"
            aria-label="Pesquisar"
            onClick={handleFilters}
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      </Grid>

      <Table
        columns={VEHICLE_TYPES_HEADERS}
        data={vehicleTypes.rows}
        onEditClick={(id: string) => handleEditVehicleType(id)}
        onDeleteClick={(id: string) => {
          setId(id);
          setFlag(true);
        }}
        notShowInput
      />
      <Pagination
        totalRecords={totalRecords}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={20}
      />
    </BoxWrapper>
  );
};

export default TableVehicleTypes;
